<template>
    <div class="cookie" v-if="showCookieWarning">
        <div class="container">
            <div class="click" v-on:click="hideCookieWarning()"><i class="fa fa-4x fa-times"></i></div>
            <h3>COOKIE</h3>
            <p>Om de gebruiksvriendelijkheid van onze website en diensten te optimaliseren maken wij gebruik van
                cookies.</p>
            <a href="#">
                <span v-on:click="showMoreInfo()" class="btn btn-primary btn-md mt-3">Meer informatie</span>
            </a>
        </div>
    </div>
</template>

<script>
  import store from '../../store'
  import {mapGetters} from 'vuex'

  export default {
    name: 'CookieWarning',
    methods: {
      hideCookieWarning () {
        store.commit('cookieWarning/hideCookieWarning')
      },
      showMoreInfo () {
        store.commit('cookieWarning/hideCookieWarning')
        this.$router.push('/cookie-verklaring')
      },
    },
    computed: mapGetters({
      showCookieWarning: 'cookieWarning/showCookieWarning',
    }),
  }
</script>

<style lang="scss">
    // Nieuwe cookie styling //
    .cookie {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: auto;
        background-color: white;
        //padding:4% 0;
        h3 {
            color: #2f9dcd;
        }

        p {
            color: #1e3e73;
            line-height: 28px;
        }

        .click {
            cursor: pointer;
            position: absolute;
            color: #1e3e73;
            top: 30px;
            right: 30px;
            width: 40px;
            z-index: 20;
        }
    }

    // Nieuwe cookie styling //


    /* Custom, iPhone Retina */
    @media only screen and (min-width: 320px) {
        .cookie {
            bottom: 0;
            padding: 10% 2% 6%;
            font-size: 14px;

            .click {
                top: 40px;
                right: 20px;
                width: 30px;
                z-index: 20;
            }
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width: 480px) {
        .cookie {
            position: fixed;
            padding: 14% 6% 8%;

            .click {
                top: 20px;
                right: 20px;
                width: 30px;
                z-index: 20;
            }
        }
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width: 768px) {
        .cookie {
            position: fixed;
            padding: 8% 5% 4%;
            font-size: 16px;

            .click {
                top: 20px;
                right: 20px;
                width: 40px;
                z-index: 20;
            }
        }
    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width: 992px) {
        .cookie {
            position: fixed;
            padding: 8% 4% 4%;

            .click {
                top: 20px;
                right: 30px;
                width: 40px;
                z-index: 20;
            }
        }
    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width: 1200px) {
        .cookie {
            position: fixed;
            padding: 4% 2% 2%;

            .click {
                top: 30px;
                right: 40px;
                width: 40px;
                z-index: 20;
            }
        }
    }
</style>
